import React from "react";

const StatusOption = ({ status, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full px-3 py-2 text-left transition-all duration-150 
        border-b border-gray-100 last:border-b-0
        ${isSelected ? "bg-gray-100 border-r-4 border-r-[#304D3C] shadow-sm" : "hover:bg-gray-100 hover:border-r-4 hover:border-r-[#304D3C] hover:shadow-sm hover:translate-x-0.5"}
      `}
      style={{
        minHeight: "48px",
        display: "block",
      }}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-3">
          {/* Indicateur de statut */}
          <div className="flex items-center">
            <span
              className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium transition-all duration-200 ${status.color}`}
              style={
                isSelected
                  ? {
                      boxShadow: "0 0 0 2px #304D3C",
                    }
                  : {}
              }
            >
              {status.label}
            </span>
          </div>

          {/* Description */}
          <div className="flex flex-col">
            <span className={`text-xs transition-colors duration-150 ${isSelected ? "text-[#304D3C]" : "text-gray-500 group-hover:text-gray-700"}`}>
              {status.description}
            </span>
          </div>
        </div>

        {/* Icône de sélection */}
        {isSelected && (
          <div className="flex items-center">
            <svg className="w-4 h-4" fill="#304D3C" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
        )}
      </div>
    </button>
  );
};

export default StatusOption;
